import { defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../_virtual/_tslib.js';
import React from 'react';
import { cleanupClassObject } from './DomUtils.js';
import { fRef } from './React.js';

var StencilHost = function StencilHost(props) {
  return /*#__PURE__*/React.createElement("div", Object.assign({}, props));
};

var Host = fRef(function (props) {
  var _cleanupClassObject;

  var hostClass = props.hostClass,
      className = props.className,
      isStencilHost = props.isStencilHost,
      children = props.children,
      as = props.as,
      otherProps = __rest(props, ["hostClass", "className", "isStencilHost", "children", "as"]);

  var HostComponent = isStencilHost ? StencilHost : as || "div";
  return /*#__PURE__*/React.createElement(HostComponent, Object.assign({
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, !!hostClass), _defineProperty(_cleanupClassObject, className, !!className), _cleanupClassObject))
  }, otherProps), children);
});

export { Host };
